<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo">
      <div class="con-img ml-3">
        <img  key="onlineImg" src="@/assets/images/portrait/small/user.png" alt="user-img" width="40" height="40" class="rounded-full cursor-pointer block" />
      </div>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  computed: {
    activeUserInfo () {
      return JSON.parse(localStorage.getItem("userInfo")) || this.$store.state.AppActiveUser
    }
  }
}
</script>
